// Mock games for iterating on the GamePreview design. The shape mirrors what
// the future `gamePreview(id: ID!): GamePreview` GraphQL query will return —
// a public subset of the internal Game type that excludes user-specific flags
// (isOwner, isParticipant, etc.).

const baseTeamsGame = {
  id: '19869022',
  status: 'CONFIRMED',
  mode: 'TEAMS',
  description:
    'Partido amistoso entre equipos. Llevá tu agua y ganas de divertirte. Cancha sintética, ambiente relajado.',
  startDate: '2026-05-01T21:00:00.000Z',
  endDate: '2026-05-01T22:00:00.000Z',
  price: 0,
  currency: 'USD',
  levels: ['INTERMEDIATE'],
  allowedGenders: ['MALE', 'FEMALE', 'NOT_SPECIFIED'],
  minAge: 25,
  maxAge: 28,
  seats: 0,
  numberOfTeams: 3,
  currentPlayers: 0,
  currentTeams: 2,
  audience: { id: 'public', name: 'Público' },
  sportType: { id: 'soccer', name: 'Fútbol', image: 'sport_soccer' },
  venue: {
    id: 'venue-1',
    name: 'Oike Koen Tamokuteki Undo Park',
    address: '1272-1 Higashishimo, Koge, Chikujo District, Fukuoka 871-0922, Japón',
    coordinate: { latitude: 33.6886, longitude: 131.0086 },
  },
  host: {
    id: 'host-1',
    firstName: 'Taro',
    lastName: 'Misaki',
    alias: 'taro',
    avatar: '',
  },
};

const baseFreeGame = {
  id: '19869099',
  status: 'CONFIRMED',
  mode: 'FREE',
  description:
    'Salida en bici al amanecer. Ritmo tranquilo, paramos en el parque a descansar y volvemos.',
  startDate: '2026-05-03T19:00:00.000Z',
  endDate: '2026-05-03T20:00:00.000Z',
  price: 0,
  currency: 'USD',
  levels: ['BEGINNER'],
  allowedGenders: ['MALE', 'FEMALE', 'NOT_SPECIFIED'],
  minAge: 0,
  maxAge: 99,
  seats: 3,
  numberOfTeams: 0,
  currentPlayers: 1,
  currentTeams: 0,
  audience: { id: 'public', name: 'Público' },
  sportType: { id: 'cycling', name: 'Ciclismo', image: 'sport_cycling' },
  venue: {
    id: 'venue-2',
    name: 'SuperCenterTRIAL NAKATSU',
    address: 'Japón, 〒871-0011 Oita, Nakatsu, Shimoikenaga, 字熊本153番地1',
    coordinate: { latitude: 33.5984, longitude: 131.1881 },
  },
  host: {
    id: 'host-1',
    firstName: 'Taro',
    lastName: 'Misaki',
    alias: 'taro',
    avatar: '',
  },
};

export const mockVariants = {
  teams: baseTeamsGame,
  free: baseFreeGame,
  full: {
    ...baseTeamsGame,
    id: '19869033',
    currentTeams: 3,
    numberOfTeams: 3,
  },
  finalized: {
    ...baseTeamsGame,
    id: '19869044',
    status: 'FINALIZED',
    startDate: '2026-04-20T21:00:00.000Z',
    endDate: '2026-04-20T22:00:00.000Z',
  },
  cancelled: {
    ...baseTeamsGame,
    id: '19869055',
    status: 'CANCELLED',
  },
  new: {
    ...baseFreeGame,
    id: '19869066',
    status: 'NEW',
  },
  paid: {
    ...baseFreeGame,
    id: '19869077',
    price: 500,
    currency: 'JPY',
  },
  private: {
    ...baseTeamsGame,
    id: '19869088',
    audience: { id: 'private', name: 'Privado' },
  },
  friends: {
    ...baseFreeGame,
    id: '19869111',
    audience: { id: 'friends', name: 'Amigos' },
    sportType: { id: 'badminton', name: 'Bádminton', image: 'sport_badminton' },
  },
};

export const getMockGame = (variantOrId) => {
  if (mockVariants[variantOrId]) {
    return mockVariants[variantOrId];
  }
  return baseTeamsGame;
};
